<app-header></app-header>

<div class="middle-content-wrap">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-3">Loading VIP diner details...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-container">
        <div class="alert alert-danger" role="alert">
            <h4 class="alert-heading">Error!</h4>
            <p>{{ error }}</p>
            <hr>
            <button class="btn btn-primary" (click)="goBack()">Go Back</button>
        </div>
    </div>

    <!-- VIP Diner Details -->
    <div *ngIf="vipDiner && !loading && !error" class="vip-diner-detail-container">
        <!-- Header -->
        <div class="globalheading dflex dflex_bet">
            <h2>
                <span routerLink="/vip-diner" class="breadcumbs">VIP Diner</span> <span
                    class="navigation-arrow">></span>
                <span>{{ vipDiner.venue_name }}</span>
            </h2>
        </div>

        <!-- VIP Diner Detail View -->
        <div class="customer-detial-view">
            <div class="row">
                <div class="col-md-12">
                    <div class="user-detail-card" style="min-height: 100%;">
                        <div class="dflex dflex_bet flex-wrap">
                            <div class="user-card-left flex-1">

                                <div class="userextrainfo">
                                    <ul>
                                        <li>
                                            <span>Date: </span>
                                            <span>{{ formatDate(vipDiner.date) }}, {{ formatTime(vipDiner.start_time)
                                                }}</span>
                                        </li>
                                        <li>
                                            <span>Address: </span>
                                            <span>{{ vipDiner.address }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="user-card-right">
                                <button class="btn btn-live-status" [class.btn-private]="!isLive"
                                    [class.btn-public]="isLive" (click)="toggleLiveStatus()"
                                    [disabled]="updatingLiveStatus">
                                    <span class="spinner-border spinner-border-sm me-2"
                                        *ngIf="updatingLiveStatus"></span>
                                    <i class="fas fa-eye" *ngIf="!isLive && !updatingLiveStatus"></i>
                                    <i class="fas fa-eye-slash" *ngIf="isLive && !updatingLiveStatus"></i>
                                    {{ updatingLiveStatus ? 'Updating...' : (isLive ? 'Public' : 'Private') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- User Selection Section -->
        <div class="basic-detail-view">
            <div class="row">
                <div class="col-md-12">
                    <div class="user-detail-card user-detail-view-card">
                        <span>Add Users to Reservation ({{ selectedUsers.length }}/2)</span>

                        <!-- Search and Filter Section -->
                        <div class="globalheading dflex dflex_bet mb-3">
                            <div class="addbtnhead">
                                <div class="page-header-right">
                                    <div class="search-wrap">
                                        <input class="form-control" placeholder="Search Users" type="text"
                                            id="searchUsers" (keyup)="onKeyUpEvent($event)" />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- Search Results Section -->
                        <div *ngIf="search || searchResults.length > 0 || searchLoading"
                            class="search-results-section mb-4">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h4>Search Results - Add Users to Reservation ({{ searchCount }})</h4>
                                <div class="d-flex gap-2">
                                    <button *ngIf="selectedUsers.length > 0" class="btn btn-primary"
                                        (click)="addSelectedUsersToReservation()" [disabled]="managingUsers">
                                        <span class="spinner-border spinner-border-sm me-2"
                                            *ngIf="managingUsers"></span>
                                        Add Users to Reservation
                                    </button>
                                    <button class="btn btn-outline-secondary" (click)="closeSearchResults()">
                                        <i class="fas fa-times"></i> Close
                                    </button>
                                </div>
                            </div>
                            <div *ngIf="searchCount > 0 || (search && !searchLoading)" class="search-summary mb-3">
                                <span class="text-muted" *ngIf="searchCount > 0">Found {{ searchCount }} user(s)
                                    matching your criteria</span>
                                <span class="text-muted" *ngIf="searchCount === 0 && search && !searchLoading">No
                                    users found matching your criteria</span>
                            </div>
                            <div class="tabledatawrap table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Gender</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let user of searchResults">
                                            <td>{{ user.id }}</td>
                                            <td>{{ user.name || 'N/A' }}</td>
                                            <td>{{ user.email || 'N/A' }}</td>
                                            <td>{{ user.phone || 'N/A' }}</td>
                                            <td>{{ user.gender || 'N/A' }}</td>
                                            <td>
                                                <div class="action-btns">
                                                    <!-- Add to Reservation - for users not already added -->
                                                    <button *ngIf="!isUserInReservation(user.id)"
                                                        class="btn btn-sm btn-primary"
                                                        (click)="addUserToReservation(user)" [disabled]="managingUsers">
                                                        <span class="spinner-border spinner-border-sm me-1"
                                                            *ngIf="managingUsers"></span>
                                                        {{ managingUsers ? 'Adding...' : 'Add to Reservation' }}
                                                    </button>
                                                    <!-- Remove from Reservation - for users already added -->
                                                    <button *ngIf="isUserInReservation(user.id)"
                                                        class="btn btn-sm btn-danger"
                                                        (click)="removeUserFromReservation(user)"
                                                        [disabled]="managingUsers">
                                                        <span class="spinner-border spinner-border-sm me-1"
                                                            *ngIf="managingUsers"></span>
                                                        <i class="fa fa-trash" *ngIf="!managingUsers"></i>
                                                        {{ managingUsers ? 'Removing...' : 'Remove' }}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="searchResults.length === 0 && !searchLoading">
                                        <tr>
                                            <td colspan="8">
                                                <div class="text-center py-4">
                                                    <i class="fas fa-search"
                                                        style="font-size: 2rem; color: #6c757d; margin-bottom: 10px;"></i>
                                                    <p class="text-muted mb-0">No users found matching your search
                                                        criteria</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div *ngIf="searchLoading" class="text-center">
                                <p>Loading search results...</p>
                            </div>

                        </div>

                        <!-- Selected Users Section -->
                        <div class="selected-users-section mt-4" *ngIf="reservationUsers.length > 0">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h4>Users Added to Reservation ({{ reservationUsers.length }}/2)</h4>
                                <div *ngIf="managingUsers" class="text-muted">
                                    <i class="fas fa-spinner fa-spin me-2"></i>
                                    Managing users...
                                </div>
                            </div>
                            <div class="tabledatawrap table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>

                                            <th>Gender</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let user of reservationUsers">
                                            <td>{{ user.id }}</td>
                                            <td>{{ user.name || 'N/A' }}</td>
                                            <td>{{ user.email || 'N/A' }}</td>
                                            <td>{{ user.phone || 'N/A' }}</td>

                                            <td>{{ user.gender || 'N/A' }}</td>
                                            <td>
                                                <div class="action-btns">
                                                    <button class="btn btn-sm btn-danger"
                                                        (click)="removeUserFromReservation(user)"
                                                        [disabled]="managingUsers">
                                                        <span class="spinner-border spinner-border-sm me-1"
                                                            *ngIf="managingUsers"></span>
                                                        <i class="fa fa-trash" *ngIf="!managingUsers"></i>
                                                        {{ managingUsers ? 'Removing...' : 'Remove' }}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Empty State -->
                        <div *ngIf="!search && searchResults.length === 0 && reservationUsers.length === 0"
                            class="text-center py-4">
                            <i class="fas fa-users" style="font-size: 2rem; color: #6c757d; margin-bottom: 10px;"></i>
                            <p class="text-muted mb-0">No users added to this reservation yet</p>
                            <small class="text-muted">Use the search above to find and add users</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Venue Image Section -->
        <div class="basic-detail-view" *ngIf="vipDiner.image">
            <div class="row">
                <div class="col-md-12">
                    <div class="user-detail-card user-detail-view-card">
                        <span>Venue Image</span>
                        <div class="venue-image-section">
                            <div class="venue-image-container">
                                <img [src]="vipDiner.image" [alt]="vipDiner.venue_name + ' image'" class="venue-image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>